import { request } from '@/utils/request'

export function sendCode(data) {
  return request({
    url: '/userInfo/sendPgCode',
    method: 'post',
    data: data
  })
}

export function login(data) {
  return request({
    url: '/userInfo/toLogin',
    method: 'post',
    data: data
  })
}

export function userInfo(data) {
	return request({
		url: '/userInfo/setUserInfo',
		method: 'POST',
		data
	},true, true)
}

export function userStepData(data) {
	return request({
		url: '/userInfo/getStepStatusInfo',
		method: 'POST',
		data
	}, true, true)
}

export function cfgIndex() {
	return request({
		url: '/api/index/getConfigForFront',
		method: 'POST'
	})
}



// WEBPACK FOOTER //
// ./src/api/info.js